import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex"
	},
	line: {
		display: "flex",
		flexDirection: "column",
		position: "relative",
		"& .extension-quote_point--bottom": {
			marginTop: "auto"
		},
		"&:before": {
			background: theme.palette.secondary.light,
			bottom: 4,
			content: "''",
			display: "flex",
			left: 3,
			top: 4,
			position: "absolute",
			width: 2,
			zIndex: -1
		}
	},
	content: {
		padding: theme.spacing(5, 3),
		[theme.breakpoints.up("md")]: {
			padding: theme.spacing(8.25, 0, 8.25, 6)
		}
	},
	text: {
		fontStyle: "italic"
	},
	author: {
		marginTop: theme.spacing(2)
	}
}));

const Quote = ({ author, text }) => {
	const css = useStyles();

	return (
		<div className={clsx("extension-quote", css.root)}>
			<div className={css.line}>
				<svg
					className="extension-quote_point--top"
					width="9"
					height="9"
					viewBox="0 0 9 9"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.487898 5.19946C-0.162633 4.54893 -0.162633 3.49421 0.487898 2.84368L2.84368 0.487898C3.49421 -0.162633 4.54893 -0.162633 5.19946 0.487898L7.55524 2.84368C8.20577 3.49421 8.20577 4.54893 7.55524 5.19946L5.19946 7.55524C4.54893 8.20577 3.49421 8.20577 2.84368 7.55524L0.487898 5.19946Z"
						fill="#9F9587"
					/>
				</svg>
				<svg
					className="extension-quote_point--bottom"
					width="9"
					height="9"
					viewBox="0 0 9 9"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.487898 5.19946C-0.162633 4.54893 -0.162633 3.49421 0.487898 2.84368L2.84368 0.487898C3.49421 -0.162633 4.54893 -0.162633 5.19946 0.487898L7.55524 2.84368C8.20577 3.49421 8.20577 4.54893 7.55524 5.19946L5.19946 7.55524C4.54893 8.20577 3.49421 8.20577 2.84368 7.55524L0.487898 5.19946Z"
						fill="#9F9587"
					/>
				</svg>
			</div>
			<div className={css.content}>
				<Typography
					className={clsx("extension-quote__text", css.text)}
					component="h2"
					dangerouslySetInnerHTML={{ __html: text }}
					variant="h4"
				/>
				<Typography
					className={clsx("extension-quote__author", css.author)}
					component="div"
					dangerouslySetInnerHTML={{ __html: author }}
					variant="caption"
				/>
			</div>
		</div>
	);
};

Quote.propTypes = {
	text: PropTypes.string.isRequired
};

export default Quote;
